export default __webpack_public_path__ + "static/media/car-solid.e1e6ff5d.svg";